import { useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import api, { formatApiError } from "@/api";
import { AuthLayout } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const { t, lang } = useLanguage();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email, lang });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err, t));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title={t("auth.forgotTitle")} testid="forgot-password-page">
      {sent ? (
        <div className="space-y-6">
          <p className="text-sm text-slate-600" data-testid="forgot-success">{t("auth.resetSent")}</p>
          <Link to="/entrar" data-testid="forgot-back-to-login" className="block text-center text-sm text-accent font-semibold hover:underline">{t("auth.backToLogin")}</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <p className="text-sm text-slate-500">{t("auth.forgotText")}</p>
          <div>
            <Label htmlFor="forgot-email">{t("auth.email")}</Label>
            <Input id="forgot-email" data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12 rounded-xl" />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="forgot-error">{error}</p>}
          <Button data-testid="forgot-submit-button" type="submit" disabled={loading} className="w-full h-12 rounded-full bg-primary hover:bg-primary/90 text-white font-semibold">{t("auth.forgotBtn")}</Button>
          <Link to="/entrar" data-testid="forgot-back-to-login" className="block text-center text-sm text-accent font-semibold hover:underline">{t("auth.backToLogin")}</Link>
        </form>
      )}
    </AuthLayout>
  );
}
